import React from 'react'
import { Redirect, Switch } from 'react-router-dom'
import { ContentRoute } from '../_metronic/layout'
import { shallowEqual, useSelector } from 'react-redux';
import { DashboardPage } from './pages/DashboardPage'
import AdminsPage from './modules/ContentManager/admins/AdminsPage'
import EditAdminsPage from './modules/ContentManager/admins/EditAdminsPage'
import TextsPage from './modules/ContentManager/texts/TextsPage'
import EditTextsPage from './modules/ContentManager/texts/EditTextsPage'
import LanguagesPage from './modules/ContentManager/languages/LanguagesPage';
import EditLanguagesPage from './modules/ContentManager/languages/EditLanguagesPage';
import CountryPage from './modules/ContentManager/country/CountryPage';
import EditCountryPage from './modules/ContentManager/country/EditCountryPage';
import LocalidadesPage from './modules/ContentManager/localidades/LocalidadesPage';
import EditLocalidadesPage from './modules/ContentManager/localidades/EditLocalidadesPage';
import ProvincePage from './modules/ContentManager/provincias/ProvincePage';
import EditProvinciasPage from './modules/ContentManager/provincias/EditProvinciasPage';
import CenterPage from './modules/ContentManager/center/CenterPage';
import EditCenterPage from './modules/ContentManager/center/EditCenterPage';
import TherapistPage from './modules/ContentManager/therapist/TherapistPage';
import EditTherapistPage from './modules/ContentManager/therapist/EditTherapistPage';
import TherapeuticGroupPage from './modules/ContentManager/therapeuticGroup/TherapeuticGroup';
import EditTherapeuticGroupPage from './modules/ContentManager/therapeuticGroup/EditTherapeuticGroup';
import ClientPage from './modules/ContentManager/client/ClientPage';
import EditClientPage from './modules/ContentManager/client/EditClientPage';
import CalendarPage from './modules/ContentManager/calendar/CalendarPage';

export default function BasePage() {
	const user = useSelector((store) => store.authentication?.user, shallowEqual);
	const isAdmin = user || user?.role !=='admin'

	return (
		<Switch>
			{/* Redirect from root URL to /dashboard. */ }
			<Redirect exact from="/" to="/dashboard" />
			<ContentRoute path="/dashboard" component={DashboardPage} />

			{/* USERS */}
			{/* Administrators */}
			<ContentRoute from="/admins" component={AdminsPage} />
			<ContentRoute from="/edit-admin/:id?" component={EditAdminsPage} />

			{/* MANAGEMENT */}
			{/* Centers */}
			<ContentRoute from="/centers" component={CenterPage} />
			<ContentRoute from="/edit-center/:id?" component={EditCenterPage} />
			{/* Therapists */}
			<ContentRoute from="/therapists" component={TherapistPage} />
			<ContentRoute from="/edit-therapist/:id?" component={EditTherapistPage} />
			{/* Clients */}
			<ContentRoute from="/clients" component={ClientPage} />
			<ContentRoute from="/edit-client/:id?" component={EditClientPage} />
			{/* Therapeutic groups */}
			<ContentRoute from="/therapeutic-groups" component={TherapeuticGroupPage} />
			<ContentRoute from="/edit-therapeutic-group/:id?" component={EditTherapeuticGroupPage} />
			{/* Calendar */}
			<ContentRoute from="/calendar" component={CalendarPage} />
			<ContentRoute from="/edit-calendar/:id?" component={CalendarPage} />

			{/* MISCELLANY */}
			{/* Paises */}
			<ContentRoute from='/countries' component={!isAdmin ? DashboardPage : CountryPage}/>
			<ContentRoute from='/edit-country/:id?' component={!isAdmin ? DashboardPage : EditCountryPage}/>
			{/* Localidades */}
			<ContentRoute from='/cities' component={!isAdmin ? DashboardPage : LocalidadesPage}/>
			<ContentRoute from='/edit-city/:id?' component={!isAdmin ? DashboardPage : EditLocalidadesPage}/>
			{/* Provincias */}
			<ContentRoute from='/provinces' component={!isAdmin ? DashboardPage : ProvincePage}/>
			<ContentRoute from='/edit-province/:id?' component={!isAdmin ? DashboardPage : EditProvinciasPage}/>
			{/* Languages */}
			<ContentRoute from='/languages' component={!isAdmin ? DashboardPage : LanguagesPage}/>
			<ContentRoute from='/edit-language/:id?' component={!isAdmin ? DashboardPage : EditLanguagesPage}/>
			{/* Texts */}
			<ContentRoute from="/texts" component={!isAdmin ? DashboardPage : TextsPage} />
			<ContentRoute from="/edit-text/:id" component={!isAdmin ? DashboardPage : EditTextsPage} />

			<Redirect to="/error" />
		</Switch>
	)
}
